export default {
  dynamicPricing: {
    title: "Dynamic Pricing",
    btn: {
      notify: "Notify",
      upload: "Upload",
      publishNow: "Publish now",
      schedule: "Schedule",
      unscheduled: "Unscheduled",
    },
    tab: {
      upload: "Upload Log",
      publication: "Publication Log",
    },
    table: {
      returnTop: "Return to the top of the result",
      upload: {
        version: "Ver.",
        note: "Note",
        prices: "Prices",
        projectPrices: "Project Prices",
        createdBy: "By",
        download: "Download",
        status: "Status",
        action: "Action",
        statusMap: {
          1: "Draft",
          2: "Active",
          3: "Scheduled",
          4: "Past",
        },
      },
      publication: {
        date: "Date",
        createdBy: "By",
        version: "Ver.",
        download: "Download",
        action: "Action",
        note: "Note",
      },
    },
    tips: {
      title: "Tips",
      publish: {
        title: "Publish now",
        content: "Activate target draft version now",
      },
      schedule: {
        title: "Schedule",
        content: "Schedule to activate target Draft version",
      },
      unschedule: {
        title: "Unschedule",
        content: "Undo Schedule action before the rate card is live",
      },
    },
    modal: {
      publish: {
        title: "Publish now",
        content:
          "Kindly notice that it may be delayed if the file size is large, but it’s coming! Are you sure you want to publish this log now?",
        cancel: "Cancel",
        confirm: "Confirm",
      },
      schedule: {
        title: "Schedule to publish?",
        startDate: "Active start date",
        startTime: "Active start time",
        startTimePlaceholder: "Select time",
        cancel: "Cancel",
        confirm: "Schedule now",
      },
      unscheduled: {
        title: "Unschedule to publish",
        content: "Are you sure you want to unschedule this log? ",
        cancel: "Cancel",
        confirm: "Confirm",
      },
      notify: {
        form: {
          title: "Email notification",
          cancel: "Cancel",
          save: "Save",
          done: "Done",
          placeholder: "Email, comma seperated",
        },
        list: {
          title: "People with access",
          remove: "Remove",
        },
        error: {
          title: "Oops!",
          content:
            "We are unable to add this email. Please make sure the email you enter belongs to internal employee and is active.",
          confirm: "OK",
        },
      },
      upload: {
        form: {
          title: "Upload file",
          upload: "Upload",
          cancel: "Cancel",
          file: {
            label: "File",
            hints: "Max upload size 20MB",
            placeholder: "Drop a file here or click to upload",
          },
          note: {
            label: "Note",
            description:
              "Add a unique description in your chosen language. HTML or emojis are not supported and will be automatically removed.",
            placeholder: "Write here",
            required: "Note is required.",
          },
        },
      },
    },
    alert: {
      publish: {
        success: "Successfully publish the log.",
      },
      schedule: {
        success: "Successfully scheduled to publish the log.",
      },
      unscheduled: {
        success: "Successfully unscheduled to publish the log.",
      },
      upload: {
        success: "Successfully uploaded the log.",
      },
    },
  },
};
